/* @flow weak */
export default function getRedirectLocationAfterGroupJoin(group) {
  return `/classes/${group.getCode()}/messages${group.canAddPeople() ? '?invite=true' : ''}`;
}



// WEBPACK FOOTER //
// ./src/utils/getRedirectLocationAfterGroupJoin.js